'use client';

import { useEffect } from 'react';

interface LocaleSyncProps {
  locale: string;
}

export function LocaleSync({ locale }: LocaleSyncProps) {
  useEffect(() => {
    const dir = locale === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir  = dir;
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
